import React__default from 'react';
import { LineItem, LineItemMedia, LineItemContent } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { Helpers } from '@grandvisionhq/inventory';
import { RemoveLineItemContainer } from '../containers/RemoveLineItemContainer.js';
import { UpdateLineItemContainer } from '../containers/UpdateLineItemContainer.js';
import { PricesContainer } from '../containers/PricesContainer.js';
import { StockAndDeliveryContainer } from '../containers/StockAndDeliveryContainer.js';
import { DiscountContainer } from '../containers/DiscountContainer.js';

const ReadyReaders = ({ lineItem , settings , labels , isLineItemClickable =true  })=>{
    const { readOnly  } = settings;
    const { availability , brand , discount , imageUrl , isGift , price , productUrl , quantity , name , power ,  } = lineItem;
    return /*#__PURE__*/ React__default.createElement(LineItem, {
        className: "line-item"
    }, /*#__PURE__*/ React__default.createElement(LineItemMedia, {
        className: "line-item__media",
        type: "image",
        href: isLineItemClickable ? productUrl : undefined,
        imageUrl: imageUrl,
        imageAlt: `${brand.name} ${brand.model}`
    }), /*#__PURE__*/ React__default.createElement(LineItemContent, {
        className: "line-item__content"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "line-item__description"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "line-item__title"
    }, name), /*#__PURE__*/ React__default.createElement(Text, {
        component: "span",
        variant: "body"
    }, brand.model, (brand === null || brand === void 0 ? void 0 : brand.modelCode) !== brand.model ? ` ${brand.modelCode}` : null), /*#__PURE__*/ React__default.createElement("div", {
        className: "line-item__spec-box"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "line-item__spec",
        key: labels.power
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "line-item__spec-label"
    }, labels.power), /*#__PURE__*/ React__default.createElement("span", {
        className: "line-item__spec-value"
    }, power, " ")))), /*#__PURE__*/ React__default.createElement("div", {
        className: "line-item__quantity-and-price"
    }, !readOnly && !isGift && /*#__PURE__*/ React__default.createElement("div", {
        className: "line-item__quantity"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "line-item__quantity-selector"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "line-item__delete-btn"
    }, /*#__PURE__*/ React__default.createElement(RemoveLineItemContainer, {
        lineItem: lineItem
    })), /*#__PURE__*/ React__default.createElement(UpdateLineItemContainer, {
        lineItem: lineItem,
        availableQuantity: Helpers.getAvailableQuantity(availability)
    }))), /*#__PURE__*/ React__default.createElement(PricesContainer, {
        discount: price.total.discount,
        originalPrice: price.total.original,
        totalPrice: price.total.gross
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: "line-item__specs-and-stock"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "line-item__specs"
    }), /*#__PURE__*/ React__default.createElement(StockAndDeliveryContainer, {
        lineItem: lineItem
    }), readOnly && /*#__PURE__*/ React__default.createElement("span", {
        className: "line-item__count"
    }, labels.quantity, ": ", quantity)), /*#__PURE__*/ React__default.createElement(DiscountContainer, {
        discount: discount
    })));
};

export { ReadyReaders };
//# sourceMappingURL=ReadyReaders.js.map
